// removed by extract-text-webpack-plugin
module.exports = {"BannerLink":"src-components-BannerLink----BannerLink-module---BannerLink---2_9Y5","ReducedBannerLink":"src-components-BannerLink----BannerLink-module---ReducedBannerLink---23mYG","Button":"src-components-BannerLink----BannerLink-module---Button---1OSVf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BannerLink/BannerLink.module.scss
// module id = 374
// module chunks = 29102153025240 163216947426909